import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  type: any;
  form: FormGroup;
  formErrors: any;

  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,

    private afs: AngularFirestore,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = data.type;
    this.formErrors = {
      hashtag: {}
    };
  }

  ngOnInit() {
    if (this.data.type == 'update') {
      this.form = this.formBuilder.group({
        hashtag: [this.data.name, Validators.required]
      });
    } else if (this.data.type == 'insert') {
      this.form = this.formBuilder.group({
        hashtag: ['', Validators.required]
      });
    }

  }
  insertHashtag(form) {

    if (form.hashtag && form.hashtag != '') {
      this.afs.collection('actualHashtags').add({
        name: form.hashtag.toLowerCase().trim(),
        weeklyCount: 0,
        isSponsored: true
      }).then(dataKey => {
        console.log(dataKey.id)
        this.afs.collection('entities').doc(dataKey.id).set({
          name: form.hashtag.toLowerCase().trim(),
          searchTerm: form.hashtag.toLowerCase().trim(),
          type: "hashtag",
          uniqueName: form.hashtag.toLowerCase().trim(),
          isSponsored: true
        });
      })
      this.dialogRef.close();

    }
  }
  close() {
    this.dialogRef.close();
  }

  updateHashtag(form) {

    if (form.hashtag && form.hashtag != '') {
      this.afs.collection('actualHashtags').doc(this.data.key).update({
        name: form.hashtag.toLowerCase().trim()
      });
      this.afs.collection('entities').doc(this.data.key).update({
        name: form.hashtag.toLowerCase().trim(),
        searchTerm: form.hashtag.toLowerCase().trim(),
        type: "hashtag",
        uniqueName: form.hashtag.toLowerCase().trim()
      });
    }
    this.dialogRef.close();
  }
  async deleteHashtag() {
    await this.afs.collection('actualHashtags').doc(this.data.key).delete();
    await this.afs.collection('entities').doc(this.data.key).delete();
    this.dialogRef.close();


  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/hashtags-list/dialog/dialog.component.ts